import React, { useEffect, useState } from "react";
import { recomposeColor, TextField } from "@mui/material";
import { SimuladorIncentivoOR } from "./SimuladorIncentivoOR";
import AgricultureIcon from "@mui/icons-material/Agriculture";
import CellTowerIcon from "@mui/icons-material/CellTower";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import StarsIcon from "@mui/icons-material/Stars";
import SimuladorNumericInput from "./SimuladorNumericInput";
import BuildIcon from '@mui/icons-material/Build';
import ConstructionIcon from '@mui/icons-material/Construction';
import BathroomIcon from '@mui/icons-material/Bathroom';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { SimuladorCobranzaOR } from "./SimuladorCobranzaOR";
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import { SimuladorPortafolioCobranza } from "./SimuladorPortafolioCobranza";
import FolderIcon from '@mui/icons-material/Folder';



const SimuladorIncentivosCobranzaScreen = ({ puesto }) => {
    const [formData, setFormData] = useState({
        nombre: "",
        puesto: "",
        fecha: "",
        monto: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const rangoRecuperacion = [
        { minimo: 0, maximo: 0.99, porcentaje: .0005 },
        { minimo: 1, maximo: 30.99, porcentaje: 0.0007 },
        { minimo: 31, maximo: 60.99, porcentaje: .0015 },
        { minimo: 61, maximo: 90.99, porcentaje: .0020 },
        { minimo: 91, maximo: 150.99, porcentaje: .0030 },
        { minimo: 151, maximo: 150000, porcentaje: 0 },
    ]

    //INTERES MORATORIO
    const [interes, setInteres] = useState({
        recuperacion: 0,
        incentivo: "",
        porcentaje: .03
    });

    const handleChangeInteres = (e) => {
        const { name, value } = e.target;
        setInteres({
            ...interes,
            [name]: value,
        });
    };

    useEffect(() => {
        if (Number(interes.recuperacion !== 0)) {
            let incentivo = 0;
            incentivo =
                Number(interes.recuperacion) * interes.porcentaje;

            setInteres({
                ...interes,
                incentivo,
            });
        }
    }, [interes.recuperacion,]);

    //MEJORA DE PROTAFOLIO
    const [portafolio, setPortafolio] = useState({
        saldo: 0,
        incentivo: "",
        porcentaje: .03
    });

    const [porcentajeAtraso, setPorcentajeAtraso] = useState(0);

    const handleChangePortafolio = (e) => {
        const { name, value } = e.target;
        setPortafolio({
            ...portafolio,
            [name]: value,
        });
    };

    const rangoPortafolio = [
        { minimo: -100000, maximo: 0, porcentaje: .80 },
        { minimo: 0.01, maximo: 3, porcentaje: 1 },
        { minimo: 3.01, maximo: 150000, porcentaje: 1.2 },
    ]

    //INCENTIVOS TOTALES
    const [incentivoRecuperacion, setIncentivoRecuperacion] = useState(0);
    const [incentivosPortafolio, setIncentivosPortafolio] = useState(0);

    const [incentivoTotal, setIncentivoTotal] = useState(0);



    useEffect(() => {
        if (Number(incentivoRecuperacion !== 0) && Number(incentivosPortafolio !== 0) && Number(interes.incentivo !== 0)) {
            let incentivo = 0;
            incentivo =
                ((Number(incentivoRecuperacion) + Number(interes.incentivo)) * Number(incentivosPortafolio)) / 100;

            setIncentivoTotal(incentivo)
        }
    }, [incentivoRecuperacion, incentivosPortafolio]);

    return (
        <>
            <div className="simulador-incentivo-form-seccion">
                <div className="simulador-incentivo-vendedor-f5">
                    <div className="fila-title-b">
                        <AttachMoneyIcon /> Recuperación
                    </div>
                    <SimuladorCobranzaOR
                        rango={rangoRecuperacion}
                        setIncentivoRecuperacion={setIncentivoRecuperacion}
                    />
                </div>

                <div className="simulador-incentivo-vendedor-f5">
                    <div className="fila-title-b">
                        <CurrencyExchangeIcon sx={{ fontSize: "18px" }} /> Recuperación de Interes Moratorio
                    </div>

                    <div className="simulador-incentivo-vendedor-f3">
                        <div className="input-section-container-numeric">
                            <div className="input-container-one">
                                <div className="input-section">
                                    <div className="input-section-label"> Recuperacion del mes ($)</div>
                                    <SimuladorNumericInput
                                        name="recuperacion"
                                        label=""
                                        value={interes.recuperacion}
                                        disabled={false}
                                        onChange={handleChangeInteres}
                                        icono="pesos"
                                    />

                                </div>
                            </div>
                            <div className="input-container-one">
                                <div className="input-section">
                                    <div className="input-section-label">Tu incentivo es de:</div>
                                    <SimuladorNumericInput
                                        name="incentivo"
                                        label=""
                                        value={interes.incentivo}
                                        disabled={true}
                                        icono="pesos"
                                        inputTotal="si"
                                    />
                                    {/* <TextField
                                // label="Nombre"
                                name="IncentivoPaqams"
                                // value={formData.incentivoPaqMaquinaria}
                                size="small"
                                disabled
                            /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="simulador-incentivo-vendedor-f5">
                    <div className="fila-title-b">
                        <FolderIcon /> Mejora de Portafolio
                    </div>
                    <SimuladorPortafolioCobranza
                        rango={rangoPortafolio}
                        saldo={portafolio.saldo}
                        setPorcentaje={setPorcentajeAtraso}
                        incentivoRecuperacion={incentivoRecuperacion}
                        setIncentivosPortafolio={setIncentivosPortafolio}
                        handleChangePortafolio={handleChangePortafolio}
                        saldoPortafolio={portafolio.saldo}
                        porcentajeAtraso={porcentajeAtraso}
                    />
                </div>
            </div >
            <div className="simulador-incentivo-nuevoformat">
                <div className="simulador-incentivo-form-titulos">
                    <span>
                        Considerando los datos ingresados, tu Incentivo total simulado es:
                    </span>
                    <SimuladorNumericInput
                        name="incentivoTotal"
                        label=""
                        value={incentivoTotal}
                        disabled={true}
                        align="centro"
                        icono="pesos"
                    />
                </div>
                <div className="simulador-incentivo-form-titulo-leyenda">
                    Este simulador presenta escenarios de compensación estimados con base en los resultados ingresados. Su contenido no representa información oficial ni compromiso de pago
                </div>
            </div>
        </>
    );
};

export default SimuladorIncentivosCobranzaScreen;
